import api from "./api";

export default class SomcService {
  async getLastImportSomcData() {
    const result = await api.get(`/v1/somc/last-import-somc-data`);
    return result.data;
  }
}
